module.exports = __webpack_public_path__ + "media/images/18px_fullstar-9f5a1f276e51ba71b48e5c57e3627a8d305abf0c3ec7b279d58b3362156ab7de.png";